// REL_1.1.15 F-262 / S-983 fix — CDN brand asset URL helper for the marketing site.
//
// SINGLE SOURCE OF TRUTH: ported verbatim from deedo-frontend's utils/getBrandAsset.ts so the
// marketing site resolves the SAME brand assets from the SAME canonical CDN container, by the
// SAME filenames. A re-upload of `logo-main.svg` (etc.) to that one `branding` container updates
// BOTH the frontend AND marketing automatically — no second/bundled copy to drift (per Infra bug
// report 2026-05-29 operator direction). The inline-SVG fallback in DeedoLogo is ONLY an
// error/404 fallback, not a second source of the canonical asset.
//
// VITE_BRAND_CDN_BASE_URL: dev = '/brand' (local static), staging/prod = Azure Blob CDN URL.
// Infrastructure owns CDN provisioning (S-789). Read at runtime from the matching .env.<mode>.

const CDN_BASE = import.meta.env.VITE_BRAND_CDN_BASE_URL ?? "/brand";
const FALLBACK_URL = `${CDN_BASE}/logo-main.svg`;

export type BrandAssetType =
  | "logo-main"
  | "logo-mark"
  | "logo-footer"
  | "logo-mobile"
  | "logo-dark"
  | "logo-social"
  | "logo-email"
  | "logo-favicon"
  | "logo-app-icon"
  | "logo-print";

const ASSET_MAP: Record<BrandAssetType, string> = {
  "logo-main":    `${CDN_BASE}/logo-main.svg`,
  "logo-mark":    `${CDN_BASE}/logo-mark.svg`,
  "logo-footer":  `${CDN_BASE}/logo-footer.svg`,
  "logo-mobile":  `${CDN_BASE}/logo-mobile.svg`,
  "logo-dark":    `${CDN_BASE}/logo-dark.svg`,
  "logo-social":  `${CDN_BASE}/logo-social.png`,
  "logo-email":   `${CDN_BASE}/logo-email.png`,
  "logo-favicon": `${CDN_BASE}/logo-favicon.ico`,
  "logo-app-icon":`${CDN_BASE}/logo-app-icon.png`,
  "logo-print":   `${CDN_BASE}/logo-print.svg`,
};

export function getBrandAsset(type: BrandAssetType): string {
  return ASSET_MAP[type] ?? FALLBACK_URL;
}

export const BRAND_ASSET_FALLBACK = FALLBACK_URL;
